import { BreadCrumb } from "primereact/breadcrumb";

const transformStringArrToBreadcrumbItems = (stringArr) => {
  try {
    return JSON.parse(stringArr).map((item) => {
      return {
        label: item,
      };
    });
  } catch (error) {
    return [];
  }
};

export const Breadcrumb = ({ style, items, lastItem }) => {
  const breadcrumbItems = transformStringArrToBreadcrumbItems(items);
  if (lastItem) breadcrumbItems.push({ label: lastItem });

  return (
    <div className="breadcrumb flex align-items-center height-40" style={style}>
      <BreadCrumb className="border-0 p-0" model={breadcrumbItems} />
    </div>
  );
};
